// Parses a "Name <email>" display string into its parts. Returns whichever side
// is parsable; both, either, or neither may be present.
export function splitNameEmail(display) {
    const trimmed = display.trim();
    if (!trimmed) {
        return {};
    }
    if (trimmed.indexOf('<') === -1) {
        if (trimmed.indexOf('@') === -1) {
            return { name: trimmed };
        }
        return { email: trimmed };
    }
    const [rawName, rawEmail] = trimmed.split('<');
    const name = rawName.trim();
    const email = rawEmail.replace('>', '').trim();
    return {
        ...(name ? { name } : {}),
        ...(email ? { email } : {}),
    };
}
// True when the display string contains a plausible email address ("Name <addr>" forms
// included). Intentionally pragmatic — local@domain.tld with no whitespace — not a full
// RFC 5322 check; the goal is to catch typos like a missing "@" before an upstream
// mail API rejects (or a parser throws on) the address.
export function isValidEmailAddress(raw) {
    const email = splitNameEmail(raw).email;
    if (!email) {
        return false;
    }
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
// True when two display strings refer to the same mailbox. Case-insensitive on the
// address part, "Name <email>"-aware. Both sides must yield a parsable email or the
// result is false.
export function isSameEmail(a, b) {
    const aEmail = splitNameEmail(a).email?.toLowerCase();
    const bEmail = splitNameEmail(b).email?.toLowerCase();
    if (!aEmail || !bEmail) {
        return false;
    }
    return aEmail === bEmail;
}
// Renders the canonical "Name <email>" display string. Falls back to a bare email when
// no name is available, and to the original raw value when even the email is missing.
export function formatNameEmail(name, emailOrRaw) {
    const email = splitNameEmail(emailOrRaw).email ?? emailOrRaw;
    const trimmedName = name?.trim();
    if (!trimmedName) {
        return email;
    }
    return `${trimmedName} <${email}>`;
}
